// import {logout} from "@base/SignInActions"

let initializer = {
    async initializeRequest(req) {},
};

export function setInitializer(newInitializer) {
    initializer = newInitializer;
}

const RESTWrapper = {
    request: async function (endpoint, payload, RESTMethod) {
        const req = {
            method: RESTMethod,
            headers: new Headers(),
            body: payload ? JSON.stringify(payload) : undefined,
        };

        await initializer.initializeRequest(req);

        if (RESTMethod === 'GET') {
            delete req.body;
        }

        const response = await fetch(endpoint, req);
        const status = response.status;
        if (status !== 200) {
            const errObject = await response.json();
            const errString =
                errObject && errObject.data && errObject.data.message
                    ? errObject.data.message
                    : 'Something went wrong.';

            /*compatibility reasons*/
            if (status === 400 || status === 500) {
                //Quick and dirty singnin error handling
                if (errObject.hasOwnProperty('signedIn')) {
                    return new Promise((resolve, reject) => {
                        reject(errObject);
                    });
                }
                //window.emmett.emit('server_error');
            }
            throw new Error(errString);
        }

        const json = await response.json();
        return {
            entity: json,
        };
    },
};

export default RESTWrapper;
